import React, { useContext, useState } from 'react';
import styles from './Retirada.module.css';
import ticket from '../styles/ticket.module.css';
import { PedidosContext } from '../../../shared/contexts/PedidosContext';
import FooterOpcoes from '../../cliente/components/FooterOpcoes';
import HeaderPageEquipe from '../components/HeaderPageEquipe';
import { FiPackage, FiCheck } from 'react-icons/fi';
import { numeroExibicaoPedido } from '../../../shared/utils/pedido';

function Retirada() {
  const { pedidos, atualizarPedidos } = useContext(PedidosContext);
  const estabelecimentoId = localStorage.getItem("estabelecimento_id");
  const nomeEstabelecimento = localStorage.getItem("nomeEstabelecimento");
  const [entregando, setEntregando] = useState(null);

  const pedidosProntos = pedidos.filter(
    p => p.status === 'pronto' &&
    String(p.id_estabelecimento) === String(estabelecimentoId)
  );

  const marcarComoEntregue = async (pedido) => {
    setEntregando(pedido.id_pedido);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await fetch(`${API_URL}/atualizar-item`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({
          numPedido: pedido.id_pedido,
          novoStatus: 'entregue',
          codigoDigitado: pedido.codigo_entrega
        })
      });

      const result = await response.json();

      if (response.ok) {
        await atualizarPedidos();
      } else {
        alert(`Erro: ${result.message || 'Erro ao atualizar pedido'}`);
      }
    } catch (error) {
      console.error("Erro ao marcar como entregue:", error);
      alert("Erro ao atualizar o pedido. Tente novamente.");
    } finally {
      setEntregando(null);
    }
  };

  return (
    <div className={styles.pagina}>
      <HeaderPageEquipe
        nomeEstabelecimento={nomeEstabelecimento}
        nomePage="Retirada"
      />

      <div className={styles.contador}>
        <span className={styles.contadorNum}>{pedidosProntos.length}</span>
        <span className={styles.contadorLabel}>
          {pedidosProntos.length === 1 ? 'pedido pronto' : 'pedidos prontos'}
        </span>
      </div>

      <div className={styles.listaPedidos}>
        {pedidosProntos.length === 0 ? (
          <div className={styles.vazio}>
            <FiPackage className={styles.vazioIcone} />
            <p>Nenhum pedido pronto para retirada.</p>
          </div>
        ) : (
          pedidosProntos.map(pedido => (
            <div key={pedido.id_pedido} className={styles.pedidoCard}>
              <div className={styles.pedidoTopo}>
                <div className={styles.pedidoId}>
                  <span className={styles.pedidoNumero}>#{numeroExibicaoPedido(pedido)}</span>
                  <span className={styles.pedidoOrigem}>
                    {pedido.origem_pedido === 'balcão' ? 'Balcão' : pedido.origem_pedido === 'garcom' ? 'Garçom' : pedido.origem_pedido === 'ifood' ? 'iFood' : 'App'}
                  </span>
                </div>
              </div>

              <div className={`${styles.pedidoDetalhes} ${ticket.ticketEdge}`} style={{ '--notch-bg': '#ffffff' }}>
                <div className={styles.pedidoInfo}>
                  <span className={styles.infoLabel}>Pagamento</span>
                  <span className={styles.infoValor}>
                    {pedido.forma_de_pagamento}
                    {pedido.troco_para ? ` · troco p/ R$ ${Number(pedido.troco_para).toFixed(2)}` : ''}
                  </span>
                </div>
                <div className={styles.pedidoInfo}>
                  <span className={styles.infoLabel}>Total</span>
                  <span className={styles.infoValorDestaque}>
                    R$ {parseFloat(pedido.total).toFixed(2)}
                  </span>
                </div>
              </div>

              <button
                className={styles.btnEntregar}
                onClick={() => marcarComoEntregue(pedido)}
                disabled={entregando === pedido.id_pedido}
              >
                {entregando === pedido.id_pedido ? (
                  'Entregando...'
                ) : (
                  <>
                    <FiCheck /> Marcar como Entregue
                  </>
                )}
              </button>
            </div>
          ))
        )}
      </div>

      <FooterOpcoes typeView="equipe" />
    </div>
  );
}

export default Retirada;
